import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NX_MODAL_DATA, NxModalRef } from '@aposin/ng-aquila/modal';
import { UserResponse } from '@interfaces/user';
import { Store } from '@ngxs/store';
import { SharedModule } from '@shared/shared.module';
import { CANCEL_REPLACE, REQUEST_CANCELLATION } from '@store/sat-motor/sat-motor.action';

@Component({
  selector: 'app-request-cancellation',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './request-cancellation.component.html',
  styleUrl: './request-cancellation.component.scss'
})
export class RequestCancellationComponent implements OnInit {

  requestCancellationForm: FormGroup;

  
  summaryData: any;
  reasonLov: any;

  isEndorsement: boolean = false;
  userInfo: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: NxModalRef<any>,
    private store: Store,
    @Inject(NX_MODAL_DATA) readonly data: any,
  ) {
    this.summaryData = data.summaryData;
    this.isEndorsement = data.isEndorsement;
  }

  ngOnInit() {
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.reasonLov = this.store.selectSnapshot<any>(state => state.SatMotorState.lov.cancelReasonList);
    
    this.requestCancellationForm = this.fb.group({
      cancellationReason: [''],
      cancelRemarks: [''],
    });

    this.initValidators();
  }

  initValidators() {
    if(this.isCoverNote) {
      if (this.summaryData.cnoteStatus != 'PENDING') {
        this.requestCancellationForm.controls['cancellationReason'].setValidators(Validators.required);
      }      
      this.requestCancellationForm.controls['cancelRemarks'].setValidators(Validators.required);
    }
  }

  submitCancellation() {
    if (this.requestCancellationForm.valid) {
      //store response to summary
      this.close({ data: this.requestCancellationForm.getRawValue(), isCancelAndReplace: false });
    } else {
      this.requestCancellationForm.markAllAsTouched();
    }
  }

  cancelReplace() {
    if (this.requestCancellationForm.valid) {
      this.close({ data: this.requestCancellationForm.getRawValue(), isCancelAndReplace: true });
    } else {
      this.requestCancellationForm.markAllAsTouched();
    }
  }

  close(param) {
    this.dialogRef.close(param);
  }

  onClickSubmitBtn() {
    if(this.userInfo.admin && this.isCoverNote && !this.isEndorsement && this.summaryData.jpjStatus == "OK" && !this.summaryData.policyNo) {
      this.submitCancellation();
    }else {
      this.cancelReplace();
    }
  }

  get isEquotation() {
    return (!this.summaryData.cnoteNo) && this.summaryData.proposalNo && !this.summaryData.draftInd;
  }

  get isCoverNote() {
    if(this.summaryData.cnoteNo || this.data.isViewQuotation) {
      return true;
    }else {
      return false;
    }
    
  }

  get activateCancelAndReplaceBtn() {
    if (!this.isEndorsement) {
      if (this.isEquotation || (this.isCoverNote && this.summaryData.jpjStatus !== "OK" && !this.summaryData.policyNo)) {
        return true;
      } else {
        return false;
      }
    }else {
      if(this.summaryData.cnoteStatus === "PENDING"
        || (this.isCoverNote && this.summaryData.cnoteStatus === "PRINTED" && this.summaryData.jpjStatus !== "OK")
        || (this.isEquotation && this.isRSEUser)
      ) {
        return true;
      }else {
        return false;
      }
    }

  }

  get isRSEUser() {
    if(this.userInfo.callCenter && this.userInfo.callCentreType == "T") {
      return true;
    }else {
      return false;
    }
  }
}
